import Main from '@/views/main.vue'

import {orderMenuRouter, orderOtherRouter} from './order'

const repairMenuRouter = {
  has: 'order',
  path: '/',
  icon: 'android-people',
  name: 'repairMenuRouter',
  title: '维修接车',
  component: Main,
  children: [
    ...orderMenuRouter
  ]
}

const repairOtherRouter = {
  path: '/',
  icon: 'android-people',
  name: 'repairOtherRouter',
  title: '维修接车',
  component: Main,
  beforeEnter: (to, from, next) => {
    // vue bug: 当repairType为number时，push/replace时都为number，当浏览器F5刷新时，会变成string
    to.meta.activeName = Number(to.query.repairType) === 1 ? 'orderGovern' : 'orderMaintenance'
    next()
  },
  children: [
    ...orderOtherRouter
  ]
}

export {repairMenuRouter, repairOtherRouter}



// WEBPACK FOOTER //
// ./src/router/repair/index.js